import React from "react";
import "./FormField.scss";

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  required?: boolean;
  className?: string;
  error?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  children,
  required = false,
  className = "",
  error,
}) => {
  return (
    <div className={`form-field ${className} ${error ? "form-field--error" : ""}`}>
      <label className="form-field__label">
        {label}
        {required && <span className="required">*</span>}
      </label>
      <div className="form-field__input">{children}</div>
      {error && <div className="form-field__error">{error}</div>}
    </div>
  );
};
